import * as React from 'react';
// import logo from './logo.svg';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './App.css';
import { Main } from './views/Main';


function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
